import { APIConfig } from "types";
import APIBase from "./apiBase";

export default class APIBsc extends APIBase {
    constructor(config?: APIConfig, logger?: (arg: string) => void) {
        if (!config) {
            config = {
                apiUrl: process.env.REACT_APP_BSCSCAN_API
            }
        }

        super(config, logger);
    }

    public async getTransactions( address, page, limit): Promise<any> {
        const result = await this.get(
            ``,
            {
                module: 'account',
                action: 'txlist',
                address: address,
                startblock: 0,
                endblock: 99999999,
                page: page,
                offset: page*limit,
                sort: 'desc',
                apikey: process.env.REACT_APP_BSCSCAN_KEY
            }
        )
        return result
    }

    public async getTokenTransfer( address, contractAddress, page, limit): Promise<any> {
        const result = await this.get(
            ``,
            {
                module: 'account',
                action: 'tokentx',
                address: address,
                contractaddress: contractAddress,
                startblock: 0,
                endblock: 99999999,
                page: page,
                offset: page*limit,
                sort: 'desc',
                apikey: process.env.REACT_APP_BSCSCAN_KEY
            }
        )
        return result
    }
    

}